import request from '@/utils/request'

let PlatformmApi = {

  /*平台管理列表*/
  list(data) {
    return request._post('/shop/plus.platformm.Index/index', data);
},
/*添加平台管理*/
add(data) {
    return request._post('/shop/plus.platformm.Index/add', data);
},
/*修改平台管理*/
edit(data) {
    return request._post('/shop/plus.platformm.Index/edit', data);
},
/*删除平台管理*/
del(data) {
    return request._post('/shop/plus.platformm.Index/del', data);
},
/*平台管理详情*/
detail(data) {
  return request._post('/shop/plus.platformm.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.platformm.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.platformm.Setting/getSetting', data, errorback);
    },
}
export default PlatformmApi;



// WEBPACK FOOTER //
// ./src/api/platformm.js